import { Auth, API } from "aws-amplify";
import { IReportTreeNode, IConfigReports } from "@vmosolutions/oc-interfaces";

export enum Type {
  SET_REPORT_NODES = "SET_REPORT_NODES",
  UPDATE_ACTIVE_PATH = "UPDATE_ACTIVE_PATH",
  SAVE_REPORT = "SAVE_REPORT",
}

export interface ISetReportNodes {
  type: Type.SET_REPORT_NODES;
  reportNodes: IReportTreeNode[];
}

export interface IUpdateActivePath {
  type: Type.UPDATE_ACTIVE_PATH;
  path: string;
}

export interface ISaveReport {
  type: Type.SAVE_REPORT;
  report: any;
}

export type Action = ISetReportNodes | IUpdateActivePath | ISaveReport;

export const updateActivePath = (path: string): IUpdateActivePath => {
  return {
    type: Type.UPDATE_ACTIVE_PATH,
    path,
  };
};

export const updateReportNodes = (reportNodes: IReportTreeNode[]): ISetReportNodes => {
  return { type: Type.SET_REPORT_NODES, reportNodes };
};

export const getAppConfigReports = async (): Promise<IConfigReports | null> => {
  try {
    const userSession = await Auth.currentSession();
    const token = userSession.getIdToken().getJwtToken();
    const response = await API.get("skytrains", "/config/reports", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
    });
    // console.log(response);
    return response;
  } catch (error) {
    // console.error(`Error: ${error.toString()}`);
    return null;
  }
};
